import {computed, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {
    AvisosObservaciones,
    EvalInterface,
    EvaluacionesInterface, EvaluacionesSolicitudInterface,
    RevisionUsuarioInterface, SolicitudEvalDocInterface, SolicitudEvalDocTipoInterface
} from "../interfaces/evaluaciones.interface";
import {environment} from "../../../../environments/environment.development";
import {EventItem} from "../../../users/interfaces/proyecto.interface";
import {catchError, throwError} from "rxjs";
const apiVucUrl = environment.apiVucUrl
@Injectable({
  providedIn: 'root'
})
export class EvaluacionesService {
    datosCargados: boolean = false;
    _evaluaciones: WritableSignal<EvaluacionesInterface[]> =signal([]);
    evaluaciones =computed(()=>this._evaluaciones())
    _checkedEvaluacionConfirm: WritableSignal <EvaluacionesInterface[]> = signal([]);
    _timelineEvents: WritableSignal <EventItem[]> = signal([]);
    timelineEvents =computed(()=>this._timelineEvents());
    _evaluacionesSolicitud: WritableSignal <EvaluacionesSolicitudInterface[]> = signal([]);
    evaluacionesSolicitud =computed(()=>this._evaluacionesSolicitud());
    _notificaciones: WritableSignal<AvisosObservaciones[]> = signal([]);
    notificaciones =computed(()=>this._notificaciones());
  constructor(private http: HttpClient) { }

    procesarInicioEvaluacion(evaluacion: EvalInterface) {
        return this.http.post<EvalInterface>(apiVucUrl + `api/v1.0/solicitud/evaluacion`, evaluacion, {observe: 'response'})
    }
    obtenerEvaluacioUsuarioDet(idSolicitud:number,uniqueIdUsuario:string,idSolicitudEval:number, typeFilter:boolean) {
        return this.http.get<EvaluacionesInterface[]>(apiVucUrl + `api/v1.0/solicitud/eval-det?idSolicitud=${idSolicitud}&uniqueIdUsuario=${uniqueIdUsuario}&idSolicitudEval=${idSolicitudEval}&typeFilter=${typeFilter}`, {observe: 'response'})
    }
    obtenerEvaluacionSolicitud(idSolicitud:number) {
        return this.http.get<EvaluacionesSolicitudInterface[]>(apiVucUrl + `api/v1.0/solicitud/eval-det/evaluaciones?idSolicitud=${idSolicitud}`, {observe: 'response'})
    }
    procesarRevisionUsuario(evaluacionRevision: RevisionUsuarioInterface[]) {
        return this.http.post<RevisionUsuarioInterface[]>(apiVucUrl + `api/v1.0/solicitud/eval-det`, evaluacionRevision, {observe: 'response'})
    }
    procesarEvalObservaciones(evalObservaciones: SolicitudEvalDocInterface) {
        return this.http.post<SolicitudEvalDocInterface>(apiVucUrl + `api/v1.0/solicitud/eval-aviso/observaciones`, evalObservaciones, {observe: 'response'})
    }
    procesarEvalDictamen(evalObservaciones: SolicitudEvalDocInterface) {
        return this.http.post<SolicitudEvalDocInterface>(apiVucUrl + `api/v1.0/solicitud/eval-doc/dictamen`, evalObservaciones, {observe: 'response'})
    }
    obtenerEvaluacioDocTipos(tipos:string[],idSolicitud:number) {
        return this.http.get<SolicitudEvalDocTipoInterface[]>(apiVucUrl + `api/v1.0/solicitud/eval-doc/tipos?tipos=${tipos}&idSolicitud=${idSolicitud}`, {observe: 'response'})
    }
    getTimeLine(idSolicitud: number,idSolicitudEval:number,uniqueId:string) {
        let url = apiVucUrl + `api/v1.0/solicitud/evaluacion/timeline/${idSolicitud}?idSolicitudEval=${idSolicitudEval}&uniqueId=${uniqueId}`;
        return this.http.get<EventItem[]>(url, {observe: 'response'})
            .pipe(
                catchError(this.handleError)
            );
    }
    obtenerAvisoObservacionesParam(idSolicitud:number, idSolicitudEval:number | null, usuario:string, type:string) {
        return this.http.get<AvisosObservaciones[]>(apiVucUrl + `api/v1.0/solicitud/evaluacion/avisos-observaciones/${idSolicitud}?idSolicitudEval=${idSolicitudEval}&usuario=${usuario}&type=${type}`, {observe: 'response'})
    }
    get checkedEvaluacionConfirm(): WritableSignal<EvaluacionesInterface[]> {
        return this._checkedEvaluacionConfirm;
    }
    set checkedEvaluacionConfirm(value: WritableSignal<EvaluacionesInterface[]>) {
        this._checkedEvaluacionConfirm = value;
    }
    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            console.error('Ocurrió un error:', error.error);
        } else {
            console.error(`code: ${error.status}, body: `, error.error);
        }
        return throwError(() => new Error('Ocurrió un error al procesar, intente mas tarde.'));
    }
}
